const storage = window.localStorage;

export default {
  /**
   * @param {string} key
   * @returns {*}
   */
  getItem(key) {
    let value = null;

    try {
      value = storage.getItem(key);
      if (value) {
        value = JSON.parse(value);
      }
    } catch (e) {
      console.error(e.message);
    }
    return value;
  },

  /**
   * @param {string} key
   * @param {Object} [defaultValue={}]
   * @returns {Object}
   */
  getObject(key, defaultValue = {}) {
    let value = this.getItem(key);

    return value !== null && typeof value === 'object' ? value : defaultValue;
  },

  /**
   * @param {string} key
   * @param {*} value
   * @param {boolean} [throwError=true]
   * @returns void
   * @throws {Error}
   */
  setItem(key, value, throwError = true) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(e.message);
      if (throwError) {
        throw e;
      }
    }
  },

  /**
   * @param {string} key
   * @param {boolean} [throwError=true]
   * @returns void
   * @throws {Error}
   */
  removeItem(key, throwError = true) {
    try {
      storage.removeItem(key);
    } catch (e) {
      console.error(e.message);
      if (throwError) {
        throw e;
      }
    }
  },

  /**
   * @param {string} key
   * @param {Function<*>} listener
   * @returns void
   */
  addStorageListener(key, listener) {
    window.addEventListener('storage', e => {
      if (e.key !== key) {
        return;
      }
      let newValue = e.newValue;

      /**
       * Браузер IE11 имеет ошибку реализации события "storage" - свойства объекта
       * события newValue и oldValue всегда равны (newValue содержит старое значение).
       * Поэтому, если значения newValue и oldValue равны, то получаем актуальное
       * значение хранилища.
       *
       * См. "Known issues" {@link https://caniuse.com/#feat=namevalue-storage}.
       */
      if (newValue === e.oldValue) {
        try {
          newValue = storage.getItem(key);
        } catch (error) {
          console.error(error);
          return;
        }
      }

      if (newValue) {
        try {
          newValue = JSON.parse(newValue);
        } catch (error) {
          console.error(error.message);
        }
      }

      listener(newValue);
    });
  }
};
